import CircleTwoToneIcon from "@mui/icons-material/CircleTwoTone";

const chip = {
  defaultProps: {
    // Set the default value for the 'icon' prop
    // icon: <CircleTwoToneIcon />,
  },
  styleOverrides: {
    root: {
      // color: "white",
      padding: 2,
    },
    icon: {
      marginLeft: "5px",
      color: "inherit",
    },
  },
};

export default chip;
